
import { ReactNode } from "react";
import { StudentSidebar } from "@/components/student-auth/StudentSidebar";
import { cn } from "@/lib/utils";

interface StudentLayoutProps {
  children: ReactNode;
  title?: string;
  description?: string;
  actions?: ReactNode;
}

export function StudentLayout({ 
  children, 
  title, 
  description,
  actions
}: StudentLayoutProps) {
  return (
    <div className="flex min-h-screen bg-background">
      <StudentSidebar />
      
      {/* Main content container - added ml-[280px] to respect sidebar width */}
      <div className="flex-1 flex flex-col min-h-screen ml-[280px]">
        <header className="sticky top-0 border-b px-8 py-4 bg-background z-10">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Header content could go here */}
            </div>
          </div>
        </header>
        
        <main className="flex-1 overflow-auto">
          <div className="p-8">
            {(title || description || actions) && (
              <div className={cn(
                "pb-6 mb-8 border-b",
                description ? "flex flex-col gap-1" : "flex items-center justify-between"
              )}>
                <div>
                  {title && <h1 className="text-2xl font-heading font-bold">{title}</h1>}
                  {description && <p className="text-muted-foreground">{description}</p>}
                </div>
                
                {actions && <div className="flex items-center gap-4 mt-4 md:mt-0">{actions}</div>}
              </div>
            )}
            
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
